import { useMutation } from "@apollo/client";
import { deleteSessionMutation } from "@RHCommerceDev/graphql-client/queries/session";
import getCountryFromUrl from "utils/getCountryFromUrl";

export const useDeleteSessionMutation = () => {
  const country = getCountryFromUrl();

  return useMutation<Mutation>(deleteSessionMutation, {
    variables: {
      country
    },
    context: {
      fetchOptions: {
        method: "POST"
      }
    }
  });
};

export default useDeleteSessionMutation;
